import { render } from "./NotificationsContent.vue?vue&type=template&id=727d1229&ts=true"
import script from "./NotificationsContent.vue?vue&type=script&lang=ts"
export * from "./NotificationsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__